<template>
<div>
    <div @mouseenter="enter_menu" @mouseleave="leave_menu" id="menu" class="skin" :style="{transform: menu_transform}" v-show="is_show">
        <ul style="list-style: none; padding: 0px;margin: 0px">
            <li class="bm-menu-btn1 menu-li-headr"><b>Selecter</b></li>
            <!--<li class="menu-li">Cancel</li>-->
            <hr style="margin: 0px">
            <li @mouseenter="enter('representation')" @mouseleave="leave('representation')" class="bm-menu-btn">Representation <i class="el-icon-caret-right" style="float: right; padding-top: 5px;"></i></li>
            <li @mouseenter="enter('color')" @mouseleave="leave('color')" class="bm-menu-btn">Color <i class="el-icon-caret-right" style="float: right;padding-top: 3px;"></i></li>
            <hr style="margin: 0px">
            <li :class="is_focus?'bm-menu-btn-clicked':'bm-menu-btn'" @mouseenter="enter('focus')" @mouseleave="leave('focus')" @click="focusClick" class="bm-menu-btn">Focus <i v-if="is_focus" class="el-icon-check" style="float: right;padding-top: 3px;"></i></li>
            <li :class="multi?'bm-menu-btn-clicked':'bm-menu-btn'" @mouseenter="enter('multi')" @mouseleave="leave('multi')" class="bm-menu-btn" @click="multi_region">Multi Region <i v-if="multi" class="el-icon-check" style="float: right;padding-top: 3px;"></i></li>
            <hr style="margin: 0px">
            <li :class="deleted?'bm-menu-btn-clicked':'bm-menu-btn'" @mouseenter="enter('delete')" @mouseleave="leave('delete')" @click="deleteClick" class="bm-menu-btn">Hide</li>
            <li @mouseenter="enter('close')" @mouseleave="leave('close')" class="bm-menu-btn" @click="close">Close </li>
            <!--<hr style="margin: 1px">-->
            <!--<li class="menu-li" style="color: red">Remove</li>-->
        </ul>
    </div>
    <ColorMenu :show="color_show"></ColorMenu>
    <Representation :show="representation_show" ></Representation>
</div>
</template>

<script>
    import ColorMenu from "./ColorMenu.vue";  
    import Representation from "./Representation.vue";  
    export default {
        name: "BaimocFooter",
        data() {
            return {
                menu_transform: 'translate3d(100px, 0px, 0px)',
                current_range: [],
                menu_show: true,
                is_show: false,
                multi: false,
                deleted: false,
                is_focus: false,
                color_show: false,
                index: 0,
                representation_show: false,
                is_enter_menu: false,
                cur_start:-1,
                cur_end:-1,
            }
        },
        watch: {
            '$store.state.sequence_menu'(data) {
                // console.log('$store.state.sequence_menu', data);
                this.is_show = data['isshow'];
                this.multi =  data["multi"];
                if (Object.prototype.hasOwnProperty.call(data, "index")) this.index =  data["index"];
                if (Object.prototype.hasOwnProperty.call(data, "delete")) this.deleted =  data["delete"][this.index];
                this.is_focus =  data["focus"];
                let index =  data["index"];
                let selected_range = this.$store.state.selected_range;
                if (selected_range['color'] === undefined){
                    selected_range['color'] = ['']
                }
                if (selected_range['representation'] === undefined){
                    selected_range['representation'] = ['']
                }
                selected_range['color'][index] = data["color"];
                selected_range['representation'][index] = data["representation"];
                this.$store.commit("selectedRangeMutation", selected_range);
                this.render_menu(data);
            },
            '$store.state.selected_range'(data) {
                this.current_range = data;
                // console.log("current_range", this.current_range)
            },
            is_show(val) {
                if(val) {
                    let vue_obj = this;
                    vue_obj
                    // setTimeout(function(){
                    //     if(!vue_obj.is_enter_menu){
                    //         vue_obj.is_show = false;
                    //         vue_obj.is_enter_menu = false;
                    //     }
                    // },5000);
                    
                }
            }
        },
        components: {
            ColorMenu,
            Representation,
        },
        // props: {
        //     show: Boolean,
        // },
        mounted() {
            let sequence_menu = this.$store.state.sequence_menu;
            this.multi =  sequence_menu["multi"];
            this.deleted =  sequence_menu["delete"];
            this.is_focus =      ["focus"];
            if (Object.prototype.hasOwnProperty.call(sequence_menu, "index")) this.index = sequence_menu["index"];
            if (Object.prototype.hasOwnProperty.call(sequence_menu, "delete")) this.deleted =  sequence_menu["delete"][this.index];
        },
        methods: {
            render_menu(data) {
                let x = data['x'];
                let y = data['y']-170;
                // 判断是否超出屏幕
                let menu_height = 230;
                let menu_width = 130;
                let screen_height = window.innerHeight;
                let screen_width = window.innerWidth;
                if(y + menu_height > screen_height){
                    y = screen_height - menu_height
                }
                if(x + menu_width > screen_width){
                    x = data['x'] - menu_width;
                }
                let leftWidth = data['leftWidth'];
                this.menu_transform = `translate3d(${x-leftWidth}px, ${y}px, 0px)`;
            },
            isshow(){
                // console.log("current_range", this.current_range)
                let structure_selection_setting = this.$store.state.structure_selection_setting;
                structure_selection_setting['hide'] = this.current_range;
                this.$store.commit('StructureSelectionSettingMutation', structure_selection_setting);
                // console.log("this.$store.state.structure_selection_setting", this.$store.state.structure_selection_setting)
                // let sequence_menu = this.$store.state.sequence_menu;
                // sequence_menu['isshow'] = this.is_show;
                // this.$store.commit('sequenceMenuMutation', sequence_menu);
                this.is_show = false;
            },
            close(){
                this.is_show = false;
                // let sequence_menu = vue_obj.$store.state.sequence_menu;
            },
            focus(){
                this.is_show = false;
            },
            focusClick(){
                let sequence_menu = this.$store.state.sequence_menu;
                this.is_focus = sequence_menu["focus"] = !sequence_menu["focus"];
                this.$store.commit("sequenceMenuMutation", sequence_menu);
                // console.log("sequence_menu", sequence_menu["focus"])
                this.is_show = false;
            },
            deleteClick(){
                let sequence_menu = this.$store.state.sequence_menu;
                let index = sequence_menu["index"]
                if (sequence_menu["delete"][index] === "") sequence_menu["delete"][index] = false;
                sequence_menu["delete"][index] = !sequence_menu["delete"][index];
                

                sequence_menu["isshow"] = false;
                this.$store.commit("sequenceMenuMutation", sequence_menu);
                this.is_show = false;
            },
            multi_region(){
                let sequence_menu = this.$store.state.sequence_menu;
                this.multi = sequence_menu["multi"] = !sequence_menu["multi"];
                this.$store.commit("sequenceMenuMutation", sequence_menu);
                    // console.log("sequence_menu", sequence_menu["multi"])
                },
            enter(event){
                // console.log("enter>>", this.color_show, this.representation_show)
                switch(event){
                    case "color":
                        this.color_show = true;
                        break;
                    case "representation":
                        this.representation_show = true;
                        break;
                }
            },
            leave(event){
                switch(event){
                    case "color":
                        this.color_show = false;
                        break;
                    case "representation":
                        this.representation_show = false;
                        break;
                }
            },
            enter_menu(){
                this.is_show = true;
                this.is_enter_menu = true;
            },
            leave_menu(){
                let vue_obj = this;
                setTimeout(function(){
                    vue_obj.is_show = false;
                    vue_obj.is_enter_menu = false;
                },1000);
            }
        },
    }
</script>

<style scoped>
    .menu-li-headr {
        font-weight: 900 !important;
        font-size: 14px !important;
        padding: 2px 5px 2px 10px;
        color: #2f3542;
    }
    .skin {
        width : 120px;
        visibility : visible;
        z-index:999;
        position: absolute;
        display: block;
        border-style: solid;
        white-space: nowrap;
        z-index: 9999999;
        box-shadow: rgb(0 0 0 / 30%) 1px 2px 2px;
        transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;
        background-color: rgb(255, 255, 255);
        border-width: 1px;
        border-radius: 4px;
        font: 14px / 21px "Microsoft YaHei";
        padding: 0px;
        border-color: #a4b0be;
        opacity: 0.95;
    }
    .bm-menu-btn {
        font-family: 'OpenSans-Semibold', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
        padding: 2px 5px 2px 10px;
        color: #2f3542;
        font-size: 12px;
        font-style: normal;
        cursor: pointer;
        /* box-shadow:0 1px 0 rgba(0,0,0,.2) inset,0 -1px 0 rgba(255,255,255,.2) inset; */
    }
    .bm-menu-btn:hover {
        background: #ecf0f1;
    }
    .bm-menu-btn-clicked {
        color: #1E90FF;
    }
</style>
